import { render, staticRenderFns } from "./ThreeDRendersPage.vue?vue&type=template&id=adfa0a08&scoped=true"
import script from "./ThreeDRendersPage.vue?vue&type=script&lang=js"
export * from "./ThreeDRendersPage.vue?vue&type=script&lang=js"
import style0 from "./ThreeDRendersPage.vue?vue&type=style&index=0&id=adfa0a08&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adfa0a08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('adfa0a08')) {
      api.createRecord('adfa0a08', component.options)
    } else {
      api.reload('adfa0a08', component.options)
    }
    module.hot.accept("./ThreeDRendersPage.vue?vue&type=template&id=adfa0a08&scoped=true", function () {
      api.rerender('adfa0a08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/ThreeDRendersPage.vue"
export default component.exports